import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgGraph = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M11.5 2.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-.934 1.581c.212.26.475.475.771.632l-1.15 6.306c-.359.043-.693.165-.99.347L4.79 7.506a2.5 2.5 0 0 0 .203-1.197zm2.246.9A2.5 2.5 0 0 0 12.5 0a2.5 2.5 0 0 0-2.494 2.69L4.434 4.92A2.5 2.5 0 1 0 3.8 8.635l4.41 3.859a2.5 2.5 0 1 0 3.456-1.206zM9.5 13.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-7-8a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGraph);
export default ForwardRef;
